import {Body, Head} from "./lib";
import {Users} from "react-feather";
import {Fragment} from "react/jsx-runtime";
import {get} from "global/slices/clients/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import InfiniteScroll from "react-infinite-scroll-component";
import {TableContainer, Table as MUITable} from "@mui/material";
import {
  Loader,
  Column,
  Skeleton,
  EndMessage,
  ComponentLoader,
} from "components";

interface TableProps {}

export const Table: React.FC<TableProps> = () => {
  const dispatch = useAppDispatch();
  const {clients, request, pagination} = useAppSelector("clients");
  const {hasMore, ser} = pagination;
  const emptyMessage = ser
    ? "No se han encontrado clientes"
    : "No hay clientes creados, crea el primero";

  return (
    <div style={{width: "100%"}}>
      <InfiniteScroll
        loader={<Loader />}
        hasMore={hasMore as boolean}
        dataLength={clients["length"]}
        scrollableTarget="scrollable"
        style={{marginBottom: !clients["length"] ? "1rem" : undefined}}
        next={() => dispatch(get({...pagination, pos: pagination["pos"] + 1}))}
        endMessage={
          !clients["length"] && !hasMore ? (
            <Fragment />
          ) : (
            <EndMessage icon={Users} data={clients} />
          )
        }
      >
        <ComponentLoader
          requestStatus={request["clients"]}
          skeleton={
            <Column width="100%">
              <Skeleton height={60} width="100%" />
              <Column gap={2} width="100%">
                <Skeleton count={11} height={68} width="100%" />
              </Column>
            </Column>
          }
          emptyUI={{
            data: clients,
            icon: Users,
            message: emptyMessage,
            style: {width: "100%"},
          }}
        >
          <TableContainer>
            <MUITable size="medium" sx={{minWidth: 750}}>
              <Head />
              <Body />
            </MUITable>
          </TableContainer>
        </ComponentLoader>
      </InfiniteScroll>
    </div>
  );
};
